import { skyFoundationSettings } from '../../services/configs/configs-service';
import { goToUrl } from '../../utils/aem-utils';

const lauchTimeout = (urlPage, minutes) => {
  setTimeout(
    () => {
      goToUrl(urlPage);
    },
    minutes * 60 * 1000
  );
};

const launchRefresh = (queryStringToAppend, minutes) => {
  const checkUrl = window.location.href.includes(queryStringToAppend);
  const urlPage = checkUrl ? window.location.href : `${window.location.href}${queryStringToAppend}`;
  lauchTimeout(urlPage, minutes);
};

/**
 * Function for refresh in home page
 *  {string} QUERY_STRING_APPEND - the string of query in the URL
 *  {number} minutes - the number of minutes of set time out for the refresh of the page
 */
export const init = () => {
  const QUERY_STRING_APPEND = '?refresh';
  const MINUTES = skyFoundationSettings.getRefreshHpMinutes();
  launchRefresh(QUERY_STRING_APPEND, MINUTES);
};
